module.exports = __webpack_public_path__ + "static/img/leader.05aaf16.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/company/leader.jpg
// module id = qkWk
// module chunks = 1